import React, { useRef, useState } from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';
import apiFetch from '../../../utils/apiFetch';
import { notify } from '../../../utils/notification';
import { reactionSlotOptions } from '../utils/reactionSlotOptions';

/** Someone in range is falling: this character can spend a Reaction and a slot so they land unhurt. */
export default function FeatherFallPrompt({ campaignId, characterId, form, combatState, onCombatChange }) {
  const [busy, setBusy] = useState(false), [error, setError] = useState(''), [slot, setSlot] = useState('0');
  const lock = useRef(false);
  const id = String(characterId);
  const offer = (combatState?.reactionOpportunities || []).find(item => item.trigger === 'falling' && item.status === 'pending'
    && item.featherFall?.some(caster => caster.characterId === id) && !item.featherAnswered?.includes(id));
  if (!offer) return null;
  const slots = reactionSlotOptions(form);
  const chosen = slots[Number(slot)] || slots[0];
  const decide = async decision => {
    if (lock.current) return;
    lock.current = true; setBusy(true); setError('');
    try {
      const response = await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/falls/${encodeURIComponent(offer.fallId)}/feather-fall`, { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ helperId: id, decision, ...(decision === 'use' ? { pool: chosen?.pool, slotLevel: chosen?.slotLevel } : {}) }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.message || 'Feather Fall could not be saved.');
      if (result.combat) onCombatChange?.(result.combat);
      if (decision === 'use') notify('Feather Fall: no damage from the fall.', 'success');
      setSlot('0');
    } catch (failure) { setError(failure.message); }
    finally { lock.current = false; setBusy(false); }
  };
  const who = offer.targetCombatantId === id ? 'You are' : `${offer.targetName || 'A creature'} is`;
  return <Modal show centered backdrop="static" keyboard={false} className="dnd-modal modern-modal" aria-label="Feather Fall">
    <Modal.Header><Modal.Title>Feather Fall</Modal.Title></Modal.Header>
    <Modal.Body>
      {error && <Alert variant="danger">{error}</Alert>}
      <p>{who} falling {offer.heightFeet} feet. Use your Reaction to land without taking damage?</p>
      {slots.length > 1 && <Form.Select className="mb-2" aria-label="Spell slot" value={slot} disabled={busy} onChange={event => setSlot(event.target.value)}>
        {slots.map((option, index) => <option key={`${option.pool}:${option.slotLevel}`} value={index}>{option.label}</option>)}
      </Form.Select>}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" disabled={busy} onClick={() => decide('skip')}>Skip</Button>
      <Button disabled={busy || !chosen} onClick={() => decide('use')}>{busy ? 'Casting…' : 'Cast Feather Fall'}</Button>
    </Modal.Footer>
  </Modal>;
}
